<template>
    <div class="looker-report-container">
      <h2>Looker Studio Report</h2>
      <iframe 
        width="1200" height="750"
        src="https://lookerstudio.google.com/embed/reporting/0c3a79d4-ac29-45d9-9e4a-fc450b015dc3/page/p_c4qtjwupqd" 
        frameborder="0" style="border:0" allowfullscreen 
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: "LookerReport",
  };
  </script>
  
  <style scoped>
  .looker-report-container {
    text-align: center;
    margin-top: 20px;
  }
  
  iframe {
    border: 1px solid #ccc;
    margin: 20px 0;
  }
  </style>
  